import React from 'react';
import ReactDOM from 'react-dom/client';
import '@link/agent/styles/index.css';
//notice: index.css must be imported before App.tsx to enable style overrides
import App from '@link/agent/App';
import { StoreProvider, store } from '@link/agent/stores';
import '@link/agent/i18n';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <StoreProvider value={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>
);
